document.addEventListener('DOMContentLoaded',()=>{
  const overlay = document.querySelector('.hotcakes-overlay');
  if(!overlay) return;

  // Show overlay after image has loaded (simple, works in most themes)
  const galleryImg = document.querySelector(
    '.product__media img, .product-single__photo img'
  );

  const reveal = () => overlay.classList.add('visible');

  if(galleryImg && !(galleryImg.complete && galleryImg.naturalWidth)){
    galleryImg.addEventListener('load', () => setTimeout(reveal, 600));
  }else{
    setTimeout(reveal, 600);
  }

  // Close button
  overlay.querySelector('.hotcakes-close')
         .addEventListener('click', ()=> overlay.remove());
});